import { render, staticRenderFns } from "./appearance.vue?vue&type=template&id=38d6cdfe&scoped=true&"
import script from "./appearance.vue?vue&type=script&lang=js&"
export * from "./appearance.vue?vue&type=script&lang=js&"
import style0 from "./appearance.vue?vue&type=style&index=0&id=38d6cdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6cdfe",
  null
  
)

export default component.exports